import PropTypes from "prop-types";

export function SkinsBar({ dataByHole, index, skinsData, carryOver }) {
  const { scores, min2 } = dataByHole;

  const findSkinsScore = scores.find((i) => i < min2);

  const skinsCount = Math.round(
    !!skinsData[index >= 0 && index - 1] &&
      dataByHole.cumulative / skinsData[0].cumulative,
  );

  const prevHoleHaveSkins = skinsData[index >= 0 && index - 1]?.scores?.find(
    (i) => i < skinsData[index >= 0 && index - 1].min2,
  );

  const nextHoleHaveSkins = skinsData[index + 1]?.scores?.find(
    (i) => i < skinsData[index + 1]?.min2,
  );

  const MAXIMUM_HOLES = 18;
  const findSkinsIndexFromEnd = skinsData
    ?.slice()
    .reverse()
    .findIndex((i) => i.diff !== 0);

  const lastedSkinIndex = MAXIMUM_HOLES - findSkinsIndexFromEnd;

  function backGroundSkins() {
    if (!findSkinsScore && !carryOver) {
      return null;
    }
    if (index < lastedSkinIndex) {
      return "#389BFF";
    }
    return null;
  }

  const style = {
    display: "flex",
    backgroundColor: backGroundSkins(),
    borderRadius: 11,
    color: "white",
    fontFamily: "SF Pro Text",
    fontSize: 11,
    borderTopRightRadius: !!nextHoleHaveSkins && 0,
    borderBottomRightRadius: !!nextHoleHaveSkins && 0,
    borderTopLeftRadius: !!prevHoleHaveSkins && 11,
    borderBottomLeftRadius: !!prevHoleHaveSkins && 11,
    justifyContent: "center",
    alignItems: "center",
    height: 20,
    marginTop: 6,
    marginBottom: 6,
  };

  function sknBorderTopLeftRadius() {
    if (prevHoleHaveSkins) {
      return 11;
    }
    return 0;
  }

  function sknBorderBottomLeftRadius() {
    if (!carryOver) {
      return 11;
    }
    if (index === 0) {
      return 11;
    }
    if (prevHoleHaveSkins) {
      return 11;
    }
    return 0;
  }

  const haveSkinStyle = {
    ...style,
    borderTopRightRadius: 11,
    borderBottomRightRadius: 11,
    borderTopLeftRadius: sknBorderTopLeftRadius(),
    borderBottomLeftRadius: sknBorderBottomLeftRadius(),
    marginRight: 3,
    marginLeft: !!prevHoleHaveSkins && 3,
  };

  const findSkinsScoreBool = !!findSkinsScore;

  return findSkinsScoreBool ? (
    <div
      style={{
        width: "100%",
        backgroundColor: "rgba(30, 38, 46, 0.9)",
      }}
    >
      <div style={haveSkinStyle}>{skinsCount === 0 ? 1 : skinsCount} SKN</div>
    </div>
  ) : (
    <div
      style={{
        width: "100%",
        backgroundColor: "rgba(30, 38, 46, 0.9)",
      }}
    >
      <div style={style} />
    </div>
  );
}
SkinsBar.propTypes = {
  carryOver: PropTypes.bool.isRequired,
  dataByHole: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  skinsData: PropTypes.arrayOf(
    PropTypes.shape({
      birdieOrBetter: PropTypes.bool,
      cumulative: PropTypes.number,
      diff: PropTypes.number,
      min1: PropTypes.number,
      min2: PropTypes.number,
      parOrBetter: PropTypes.bool,
      perHole: PropTypes.number,
      scores: PropTypes.arrayOf(PropTypes.number),
      skinsWon: PropTypes.number,
      slice: PropTypes.func,
    }),
  ).isRequired,
};
